import React from "react";
import WelcomeBanner from "components/sections/WelcomeBanner";
import OurServices from "components/sections/OurServices";
import AICapabilities from "components/sections/AICapabilities";
import TechnologiesStack from "components/sections/TechnologiesStack";
import EngagementModels from "components/sections/EngagementModels";
import Testimonals from "components/sections/Testimonals";

const HomePage = () => {
  return (
    <>
      <WelcomeBanner />
      <OurServices />
      <AICapabilities />
      <TechnologiesStack />
      <EngagementModels />
      <Testimonals />
    </>
  );
};

export default HomePage;
